export const getPartnerAdminSteps = () => [

  // ── Step 1 — Welcome ──────────────────────────────────────────────────────
  {
    target: null,
    isWelcome: true,
    title: 'Welcome, Partner!',
    content: 'Your hub for managing client tenants and distributing dashboards, workflows, and apps across your network.',
  },

  // ── Step 2 — Tenants ──────────────────────────────────────────────────────
  {
    target: '#sidebar-tenants',
    title: 'Your Tenants',
    content: 'Onboard new clients and manage existing workspaces within your partner scope.',
    skipIfNotFound: true,
    scrollIntoView: true,
  },

  // ── Step 3 — Users ────────────────────────────────────────────────────────
  {
    target: '#sidebar-users',
    title: 'User Management',
    content: 'Manage users and access rights for your partner organisation.',
    skipIfNotFound: true,
    scrollIntoView: true,
  },

  // ── Step 4 — Flows ────────────────────────────────────────────────────────
  {
    target: '#sidebar-flows',
    title: 'Flow Builder',
    content: 'Build automation workflows that you can share across all your tenants.',
    skipIfNotFound: true,
    scrollIntoView: true,
  },

  // ── Step 5 — Dashboards ───────────────────────────────────────────────────
  {
    target: '#sidebar-dashboards',
    title: 'Dashboard Publishing',
    content: 'Create BI dashboards once and publish them out to your client organisations.',
    skipIfNotFound: true,
    scrollIntoView: true,
  },

  // ── Step 6 — Business Apps ────────────────────────────────────────────────
  {
    target: '#sidebar-business-apps',
    title: 'App Bundles',
    content: 'Package dashboards and workflows into branded apps to deploy to your tenants.',
    skipIfNotFound: true,
    scrollIntoView: true,
  },

  // ── Step 7 — Agentic Insights ───────────────────────────────────────────────────
  {
    target: '#sidebar-ai-insight',
    title: 'Agentic Insights',
    content: 'Enable AI-powered natural language analytics for your tenant environments.',
    skipIfNotFound: true,
    scrollIntoView: true,
  },

  // ── Step 8 — Data Sources ─────────────────────────────────────────────────
  {
    target: '#sidebar-datasources',
    title: 'Data Sources',
    content: 'Manage data connections that power your shared dashboards and workflows.',
    skipIfNotFound: true,
    scrollIntoView: true,
  },

  // ── Step 9 — Scheduler ────────────────────────────────────────────────────
  {
    target: '#sidebar-automations',
    title: 'Scheduler',
    content: 'Configure schedules for data refreshes and workflow automations.',
    skipIfNotFound: true,
    scrollIntoView: true,
  },

  // ── Step 10 — Credits ─────────────────────────────────────────────────────
  {
    target: '#sidebar-credits',
    title: 'Credit Management',
    content: 'Monitor usage and allocate your credit pool across your various tenants.',
    skipIfNotFound: true,
    scrollIntoView: true,
  },

  // ── Step 11 — Finish ──────────────────────────────────────────────────────
  {
    target: null,
    isWelcome: true,
    title: "You're all set!",
    content: "You've seen all the key areas of your partner console. Restart this tour any time from your profile menu.",
  },

];
